// extracted by mini-css-extract-plugin
module.exports = {"icon":"project-card-icon_icon__LjmE8","iconCount":"project-card-icon_iconCount__8REU8"};